// extracted by mini-css-extract-plugin
export default {"KioskHome":"Kiosk_KioskHome__zxmMV"};